import { useMemo, useRef, useState } from "react";
import { useQuery } from "react-query";

import { CCard, CCardBody } from "@coreui/react";

import { khoApi } from "src/1/apis/kho.api";
import { CTable } from "src/1/common/components/others";
import { warningDelete } from "src/App";
import { CCheckbox } from "src/common/components/controls";

import { WarehouseFormModal, WarehouseToolbar } from "../../components";

export default function WarehouseListPage() {
  //#region Data
  const modalRef = useRef();

  const [params, setParams] = useState({ page: 1, size: 10 });
  const [selectedId, setSelectedId] = useState("");

  const { data, refetch, isFetching } = useQuery({
    queryKey: ["danh-sach-kho", params],
    queryFn: () => khoApi.getPaginate(params),
    select: (response) => response?.data,
  });

  const listData = useMemo(() => data?.data ?? [], [data]);
  //#endregion

  //#region Event
  const onPageChange = (newPage) =>
    setParams((prev) => ({ ...prev, page: newPage }));

  const onLimitChange = (newLimit) =>
    setParams((prev) => ({ ...prev, size: newLimit, page: 1 }));

  const onAdd = () => modalRef.current?.open();

  const onEdit = () => modalRef.current.open(selectedId);

  const onRemove = () => {
    warningDelete({
      onConfirm: () => khoApi.delete(selectedId),
      onSuccess: () => {
        refetch();
        return "Xóa thành công";
      },
      onError: (error) => error?.message || "Xóa không thành công!",
    });
  };
  //#endregion

  //#region Render
  const headers = [
    {
      key: "selection",
      label: "",
      align: "center",
      width: 30,
      cellRender: (value, record) => (
        <CCheckbox
          value={selectedId === record?.id}
          onChange={() => {
            if (selectedId === record?.id) {
              setSelectedId("");
            } else {
              setSelectedId(record?.id);
            }
          }}
        />
      ),
    },
    { key: "code", label: "Mã kho", width: 150 },
    { key: "name", label: "Tên kho", align: "left" },
    { key: "address", label: "Địa chỉ", align: "left" },
  ];
  return (
    <>
      <WarehouseToolbar
        canEdit={selectedId}
        canRemove={selectedId}
        onAdd={onAdd}
        onEdit={onEdit}
        onRemove={onRemove}
      />

      <CCard>
        <CCardBody className="pt-0 px-0">
          <div className="mt-3">
            <CTable
              loading={isFetching}
              headers={headers}
              data={listData}
              fontSizeBody={16}
              divider
              page={params?.page}
              pages={data?.metadata?.last_page}
              limit={params?.size}
              total={data?.metadata?.total}
              onPageChange={onPageChange}
              onLimitChange={onLimitChange}
            />
          </div>
        </CCardBody>
      </CCard>

      <WarehouseFormModal ref={modalRef} refetch={refetch} />
    </>
  );
  //#endregion
}
